<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <p class="text-xs-center subheading">
          {{ $t('message.instructions.incCertificationUpload1') }}
          <a href="#" @click.prevent="showLegalBizDocsDialog = true">here</a>
          {{ $t('message.instructions.incCertificationUpload2') }}
        </p>
        <br />
        <p
          class="text-xs-center subheading font-italic"
          v-if="this.$store.getters.isAcceptanceNowSelected"
        >
          {{ $t('message.instructions.incCertificationUpload.note.anow') }}
        </p>
      </v-flex>

      <v-flex xs2>
        <v-tooltip v-if="this.$store.getters.getIncArticles.length > 0" bottom>
          <v-flex
            row
            wrap
            class="btn-wrapper text-xs-right"
            align-end
            slot="activator"
          >
            <label for="uploadInput">
              <img
                src="static/icons/cloud_upload_blue.png"
                width="44"
                style="cursor: pointer;"
              />
            </label>
            <input
              type="file"
              id="uploadInput"
              :accept="fileUploadValidTypes"
              @change="handleFileUpload($event.target.name, $event.target.files)"
            />
          </v-flex>
          <span>{{ $t('message.upload') }}</span>
        </v-tooltip>
      </v-flex>

      <v-container
        grid-list-md
        v-if="this.$store.getters.getIncArticles.length > 0"
      >
        <v-data-table
          :headers="headers"
          :items="this.$store.getters.getIncArticles"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.incCertificationFilename }}</td>
            <td nowrap>{{ formatDate(props.item.lastUpdateDate) }}</td>

            <td class="text-xs-right" nowrap>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click="remove(props.item)"
                  icon
                  class="grey--text"
                >
                  <img src="static/icons/delete_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.remove') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-container>

      <v-container
        v-if="this.$store.getters.getIncArticles.length == 0"
        grid-list-md
      >
        <v-layout column fill-height class="empty-list">
          <label for="uploadInput2" class="empty-list-input">
            <img
              src="static/icons/cloud_upload_blue.png"
              width="44"
              style="cursor: pointer;"
            />
          </label>
          <input
            type="file"
            id="uploadInput2"
            :accept="fileUploadValidTypes"
            @change="handleFileUpload($event.target.name, $event.target.files)"
          />
        </v-layout>
      </v-container>
    </v-layout>

    <v-dialog v-model="showLegalBizDocsDialog" max-width="40%">
      <v-card>
        <v-card-title class="justify-center" primary-title>
          <h2>Valid Business Legal Documents</h2>
        </v-card-title>

        <v-card-text mx-5>
          <v-flex
            v-for="orgType in this.$store.getters.getOrgTypes"
            my-2
            :key="orgType.value"
            mx-1
          >
            <input
              type="radio"
              :id="orgType.value"
              v-model="selectedEntityType"
              name="orgTypeRadio"
              :value="orgType.value"
            />
            <label for="orgType.value">{{ orgType.text }}</label>
          </v-flex>

          <v-flex my-3></v-flex>
          <v-divider></v-divider>
          <v-flex my-3></v-flex>

          <ul class="org-list" v-show="selectedEntityType == 'CORPORATION'">
            <li>{{ $t('message.entityDocTypes.articleOfIncorporation') }}</li>
            <li>{{ $t('message.entityDocTypes.fictitiousName') }}</li>
            <li>{{ $t('message.entityDocTypes.boardOfDirectors') }}</li>
          </ul>

          <ul class="org-list" v-show="selectedEntityType == 'S_CORPORATION'">
            <li>{{ $t('message.entityDocTypes.articleOfIncorporation') }}</li>
            <li>{{ $t('message.entityDocTypes.fictitiousName') }}</li>
            <li>{{ $t('message.entityDocTypes.boardOfDirectors') }}</li>
          </ul>

          <ul class="org-list" v-show="selectedEntityType == 'PARTNERSHIP'">
            <li>{{ $t('message.entityDocTypes.articleOfIncorporation') }}</li>
            <li>{{ $t('message.entityDocTypes.fictitiousName') }}</li>
            <li>{{ $t('message.entityDocTypes.partnershipAgreement') }}</li>
          </ul>

          <ul class="org-list" v-show="selectedEntityType == 'LLC'">
            <li>{{ $t('message.entityDocTypes.articleOfIncorporation') }}</li>
            <li>{{ $t('message.entityDocTypes.fictitiousName') }}</li>
            <li>{{ $t('message.entityDocTypes.operatingAgreement') }}</li>
          </ul>

          <ul class="org-list" v-show="selectedEntityType == 'SOLE_PROPRIETOR'">
            <li>{{ $t('message.entityDocTypes.solePropSsn') }}</li>
            <li>{{ $t('message.entityDocTypes.solePropJointDBA') }}</li>
            <li>{{ $t('message.entityDocTypes.solePropUsingTin') }}</li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="btn-secondary"
            @click.native="showLegalBizDocsDialog = false"
            >{{ $t('message.close') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import EmptyList from '../util/EmptyList'

export default {
  data: () => ({
    selectedEntityType: 'CORPORATION',
    showLegalBizDocsDialog: false,
    incArticle: {},
    headers: [
      { text: 'File Name', value: 'incCertificationFilename', sortable: false },
      { text: 'File Upload Date', value: 'lastUpdateDate', sortable: false },
      { value: '', sortable: false }
    ],
    valid: true,
    saveDisabled: false,
    dialog: false,
    loading: false,
    fileUploadValidTypes: ".pdf,application/pdf,*.jpg,image/jpg,.jpeg,/image/jpeg,.png,image/png"
  }),
  methods: {
    handleFileUpload(fieldName, fileList) {
      if (this.checkAndConfirmInvalidate()) {
        const file = fileList[0]

        if (file) {
          this.loading = true
          var fileFormData = new FormData()
          fileFormData.append('file', file)
          this.$store.commit('setLoading', true)
          axiosAuthInstance
            .post(
              'api/v1/incArticle/upload/' +
              this.$store.getters.getDealerApplication.id,
              fileFormData,
              {headers: {'Content-Type': 'multipart/form-data'}}
            )
            .then(response => {
              this.$store.getters.getIncArticles.push({})
              var index = this.$store.getters.getIncArticles.length - 1
              this.$store.getters.getIncArticles[index] = response.data
              this.$store.getters.getIncArticles[
                index
                ].lastUpdateDate = this.currentDateForJson()
              this.notifyInfo('File uploaded')
              this.checkFormComplete()
            })
            .catch(error => {
              this.notifyAxiosError(error, 'Business document upload failed')
            })
            .then(() => {
              if (this.$store.getters.isApplicationJustInvalidated) {
                this.$store.commit('setApplicationJustInvalidated', false)
                this.$router.go() //reload to pick up all server side changes
              } else {
                this.loading = false
                this.$store.commit('setLoading', false)
              }
            })
        }
      }
    },
    remove(lnArticlesInfo) {
      if (confirm('Are you sure you want to remove this business document?')) {
        axiosAuthInstance
          .delete('api/v1/incArticle/' + lnArticlesInfo.id)
          .then(response => {
            const index = this.$store.getters.getIncArticles.indexOf(
              lnArticlesInfo
            )
            this.$store.getters.getIncArticles.splice(index, 1)
            this.checkFormComplete()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'Deleting business document failed'
            )
          })
      }
    },
    checkFormComplete() {
      var completeForm = this.$store.getters.getIncArticles.length > 0
      this.$store.commit('setIncArticlesComplete', completeForm)
    }
  },
  mounted() {
    axiosAuthInstance
      .get(
        'api/v1/incArticle/application/' + this.$store.getters.getApplicationId
      )
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.$store.commit('setIncArticles', response.data)
        }
        this.checkFormComplete()
      })
      .catch(error => {
        this.notifyAxiosError(error, 'Failed to fetch business documents.')
      })
  },
  components: {
    'empty-list': EmptyList
  }
}
</script>

<style>
.org-list {
  list-style: disc;
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Application/IncArticles.vue